export default "__VITE_ASSET__CFWAp96R__"